import React, { useRef, useEffect, useState } from "react";

// Import font awesome package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

import "../../styles/Header/Header.scss";
const Header = ({ darkTheme }) => {
  const navLinkAbout = useRef();
  const navLinkWork = useRef();
  const navLinkContact = useRef();
  const navLinkBlogs = useRef();

  const [isAboutHovered, setIsAboutHovered] = useState(false);
  const [isWorkHovered, setIsWorkHovered] = useState(false);
  const [isContactHovered, setIsContactHovered] = useState(false);
  const [isBlogsHovered, setIsBlogsHovered] = useState(false);

  useEffect(() => {
    const route = document.getElementsByClassName("header__route");
    for (let i = 0; i <= route.length; i++) {
      route[i]?.addEventListener("mouseover", function () {
        this.nextSibling.classList.add("header__route-bg-animation");
      });
      route[i]?.addEventListener("mouseout", function () {
        this.nextSibling.classList.remove("header__route-bg-animation");
      });
    }
  });

  function showHideNavbar() {
    const navLinksDisplay = document.getElementById("header__nav-links");
    const iconMiddleLine = document.getElementById(
      "header__hamburger-middle-line"
    );
    const iconTopLine = document.getElementById("header__hamburger-top-line");
    const iconBottomLine = document.getElementById(
      "header__hamburger-bottom-line"
    );
    if (navLinksDisplay.style.display === "flex") {
      navLinksDisplay.style.display = "none";
      iconMiddleLine.style.display = "inline-block";
      iconTopLine.classList.remove("header__icon-line-animate");
      iconBottomLine.classList.remove("header__icon-bottom-line-animate");
    } else {
      navLinksDisplay.style.display = "flex";
      iconMiddleLine.style.display = "none";
      iconTopLine.classList.add("header__icon-line-animate");
      iconBottomLine.classList.add("header__icon-bottom-line-animate");
    }
  }

  return (
    <>
      <div className={`header ${darkTheme ? "dark" : "light"}`}>
        <div className="header__container">
          <div className="header__logo">
            <span
              data-aos="fade-down"
              data-aos-delay="0"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              P
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="700"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              o
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="800"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              r
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="900"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              t
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="1000"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              f
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="1100"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              o
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="1200"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              l
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="1300"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              i
            </span>
            <span
              data-aos="fade-down"
              data-aos-delay="1400"
              style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
            >
              o
            </span>
          </div>
          <div className="header__hamburger-icon" onClick={showHideNavbar}>
            <span id="header__hamburger-top-line"></span>
            <span id="header__hamburger-middle-line"></span>
            <span id="header__hamburger-bottom-line"></span>
          </div>
          <div className="header__nav-links" id="header__nav-links">
            <ul>
              <div className="header__nav-links-container">
                <li
                  className="header__route"
                  ref={navLinkAbout}
                  data-aos="fade-down"
                  data-aos-delay="0"
                >
                  <a
                    href="#about"
                    onMouseEnter={() => setIsAboutHovered(true)}
                    onMouseLeave={() => setIsAboutHovered(false)}
                    style={{
                      color: isAboutHovered
                        ? darkTheme
                          ? "#ff6347"
                          : "#00ffff"
                        : darkTheme
                        ? "#00ffff"
                        : "#ff6347",
                    }}
                  >
                    About
                  </a>
                </li>
                <div className="header__route-bg"></div>
              </div>
              <div className="header__nav-links-container">
                <li
                  className="header__route"
                  ref={navLinkWork}
                  data-aos="fade-down"
                  data-aos-delay="200"
                >
                  <a
                    href="#work"
                    onMouseEnter={() => setIsWorkHovered(true)}
                    onMouseLeave={() => setIsWorkHovered(false)}
                    style={{
                      color: isWorkHovered
                        ? darkTheme
                          ? "#ff6347"
                          : "#00ffff"
                        : darkTheme
                        ? "#00ffff"
                        : "#ff6347",
                    }}
                  >
                    Works
                  </a>
                </li>
                <div className="header__route-bg"></div>
              </div>
              <div className="header__nav-links-container">
                <li
                  className="header__route"
                  ref={navLinkBlogs}
                  data-aos="fade-down"
                  data-aos-delay="0"
                >
                  <a
                    href="#blogs"
                    onMouseEnter={() => setIsBlogsHovered(true)}
                    onMouseLeave={() => setIsBlogsHovered(false)}
                    style={{
                      color: isBlogsHovered
                        ? darkTheme
                          ? "#ff6347"
                          : "#00ffff"
                        : darkTheme
                        ? "#00ffff"
                        : "#ff6347",
                    }}
                  >
                    Blogs
                  </a>
                </li>
                <div className="header__route-bg"></div>
              </div>
              <div className="header__nav-links-container">
                <li
                  className="header__route"
                  ref={navLinkContact}
                  data-aos="fade-down"
                  data-aos-delay="300"
                >
                  <a
                    href="#contact"
                    onMouseEnter={() => setIsContactHovered(true)}
                    onMouseLeave={() => setIsContactHovered(false)}
                    style={{
                      color: isContactHovered
                        ? darkTheme
                          ? "#ff6347"
                          : "#00ffff"
                        : darkTheme
                        ? "#00ffff"
                        : "#ff6347",
                    }}
                  >
                    Contact me
                  </a>
                </li>
                <div className="header__route-bg"></div>
              </div>
              <div className="header__social">
                <p className="header__linkedin">
                  <a
                    href="https://www.linkedin.com/in/aquibpy/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <FontAwesomeIcon icon={faLinkedin} size="2x" />
                  </a>
                </p>

                <p className="header__github">
                  <a
                    href="https://github.com/AquibPy"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <FontAwesomeIcon icon={faGithub} size="2x" />
                  </a>
                </p>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
